export const envConfig = {
    UBISCORE_API_URL: process.env.NEXT_PUBLIC_UBISCORE_API_URL,
    UBISCORE_WEBSITE_URL: process.env.NEXT_PUBLIC_UBISCORE_WEBSITE_URL ?? 'https://www.ubiscore.com',
};
